

<form class="login-form" #base="ngForm" (submit)="convert(base.value)">
    

    <mat-form-field class="csp1" appearance="outline">
        <mat-label>Enter Base64</mat-label>
        <textarea matInput type="text" #first name='first' [(ngModel)]="firstone" class="csp2"></textarea>
    </mat-form-field>
 
<br>
    <button class="submitBtn" type="submit" mat-button class="csp3">convert</button>

</form>

<h5>
